module.exports = __webpack_public_path__ + "static/media/huang-id.69fce288.jpg";